import { DEFAULT_LOCALE } from "@utils/default";
import { notFound } from "next/navigation";

import { Community } from "@/types";

// interface Community {
//   categoryId: string;
//   slug: string;
// }

export async function getClientCommunities(locale = "en-ae") {
  try {
    const res = await fetch(`/api/communities?locale=${locale}`);
    const data = await res.json();
    return data?.communities || data?.communities || [];
  } catch (e) {
    console.error("Community Fetch Error", e);
    return [];
  }
}

export function createProjectUrl(
  communities: Community[],
  originalUrl: string,
  locationId: string,
  slug?: string,
  projectSlug?: string,
  locale: string = DEFAULT_LOCALE,
  isPropertyType?: boolean,
  isSitemapUrl?: boolean | false,
): string {
  // console.log("communitiesData", communities);
  if (!Array.isArray(communities)) {
    console.error("Invalid communities data", communities);
    return originalUrl;
  }
  const community = communities?.find((c) => c?.categoryId === locationId);
  const prefix = isSitemapUrl ? "" : `/${locale}/`;
  // console.log("originalUrloriginalUrl", originalUrl, locationId, slug, projectSlug, isPropertyType, community, communities);
  // if (isPropertyType) {
  //   return community ? `/${locale}/communities/${community.slug}/projects/${projectSlug}/properties/${slug}` : originalUrl;
  // }
  // return community ? `/${locale}/communities/${community.slug}/projects/${slug}` : originalUrl;
  if (isPropertyType) {
    return community
      ? `${prefix}communities/${community?.slug}/projects/${projectSlug}/properties/${slug}`
      : `${prefix}projects/${projectSlug}/properties/${slug}`;
  }
  return community ? `${prefix}communities/${community.slug}/projects/${slug}` : `${prefix}projects/${slug}`;
}

export function validateLocationIdAgainstCommunities(communities: Community[], locationId?: string | number | null): boolean | void {
  if (!locationId) return;

  const isValid = communities?.some((community) => community?.categoryId === locationId?.toString());
  // console.log("isValid", isValid);
  return isValid;
  // if (isValid) {
  //   console.warn(`Invalid locationId (${locationId}) — redirecting to 404`);
  //   notFound();
  // }
}

export function validateCommunityNameAgainstCommunities(
  communities: Community[],
  community?: string | number | null,
): { isValid: boolean; matchedCommunity: Community | null } {
  if (!community) return { isValid: false, matchedCommunity: null };

  // First, try to match by slug
  let matchedCommunity = communities?.find((item) => item?.slug === community) || null;

  // If no match found, try to match by categoryId
  if (!matchedCommunity) {
    matchedCommunity = communities?.find((item) => item?.categoryId === community) || null;
  }

  const isValid = !!matchedCommunity;

  return { isValid, matchedCommunity };
}

export function isUnitFormatLoose(raw?: string): boolean {
  if (!raw) return false;
  const s = raw.trim().toLowerCase();

  const parts = s.split("/");
  if (parts.length !== 3) return false;

  const re = /^[a-z0-9]+$/; // letters or digits only
  return re.test(parts[0]) && re.test(parts[1]) && re.test(parts[2]);
}
